/** The yellow notice box: gold border, gold wash, ink text. The staging banner,
 *  every sign-in card's dev-code notice and the referee claim refusals wear it;
 *  the owner asked for the refusal to get "same treatments as 'test
 *  environment'" (2026-09-18). One constant, so they cannot stop matching.
 *  Callers add `font-bold` themselves where the notice is a true warning. */
export const NOTICE_CLASS = 'rounded-lg border border-brand-gold bg-brand-gold/15 px-3 py-2 text-sm text-ink'
